import React from "react";
import classes from "../../ARC_Reconciliation/Sales/GST-1_Reconciliation/GSTReconciliation.module.css";


const CashLedgerTable = ({ data }) => {
    const formatCurrency = (value) => value ? `₹${value.toLocaleString("en-IN")}` : "-";

    return (
        <div
            className="responsive-table"
            style={{ scrollbarWidth: "thin", scrollbarHeight: '25px', maxHeight: '63vh' }}
        >
            <table className={classes.AllInvoiceReconTableCss}>
                <thead>
                    <tr>
                        <th rowSpan={2} style={{ width: '3%' }}>Date of deposit/Debit</th>
                        <th rowSpan={2} style={{ width: '3%' }}>Time of deposit</th>
                        <th rowSpan={2} style={{ width: '3%' }}>Reporting date (by bank)</th>
                        <th rowSpan={2} style={{width:'6%'}}>Reference No</th>
                        <th rowSpan={2} style={{ width: '3%' }}>Tax Period</th>
                        <th rowSpan={2} style={{ width: '5%' }}>Description</th>
                        <th rowSpan={2} style={{ width: '3%' }}>Transaction Type</th>
                        {["Integrated Tax", "Central Tax", "State Tax", "Cess Tax", "Integrated Tax Balance", "Central Tax Balance", "State Tax Balance", "Cess Tax Balance"].map((taxType) => (
                            <th colSpan={6} key={taxType} align="center">{taxType}</th>
                        ))}
                    </tr>
                    <tr>
                        {[...Array(8)].map((_, i) => (
                            ["Tax", "Interest", "Penalty", "Fee", "Others", "Total"].map((header) => (
                                <th key={i + header}>{header}</th>
                            ))
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} style={{ height: '45px' }}>
                                <td>{row.date_of_deposit || "-"}</td>
                                <td>{row.time_of_deposit || "-"}</td>
                                <td>{row.reporting_date || "-"}</td>
                                <td>{row['reference_no'] || "-"}</td>
                                <td>{row.tax_period || "-"}</td>
                                <td>{row.description || "-"}</td>
                                <td>{row.transaction_type || "-"}</td>
                                {
                                    [
                                        "igst_tax", "igst_interest", "igst_penalty", "igst_fee", "igst_others", "igst_total",
                                        "cgst_tax", "cgst_interest", "cgst_penalty", "cgst_fee", "cgst_others", "cgst_total",
                                        "sgst_tax", "sgst_interest", "sgst_penalty", "sgst_fee", "sgst_others", "sgst_total",
                                        "cess_tax", "cess_interest", "cess_penalty", "cess_fee", "cess_others", "cess_total",
                                        "igst_bal_tax", "igst_bal_tax", "igst_bal_tax", "igst_bal_tax", "igst_bal_tax", "igst_bal_tax",
                                        "cgst_bal_tax", "cgst_bal_interest", "cgst_bal_penalty", "cgst_bal_fee", "cgst_bal_others", "cgst_bal_total",
                                        "sgst_bal_tax", "sgst_bal_interest", "sgst_bal_penalty", "sgst_bal_fee", "sgst_bal_others", "sgst_bal_total",
                                        "cess_bal_tax", "cess_bal_interest", "cess_bal_penalty", "cess_bal_fee", "cess_bal_others", "cess_bal_total",
                                    ].map((type, i) => (

                                        <td key={i}>{formatCurrency(row[type])}</td>

                                    ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={50} style={{ textAlign: "center", fontWeight: "bold" }}>Loading… Please wait</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CashLedgerTable;
